import React from 'react';

import OptionalLink from "../OptionalLink";
import { OptionsButton } from "../Buttons";
import StatsIcons from "../StatsIcons";
import Badge, { BadgeInterface } from "../Badge";
import './style.scss';

interface propsInterface {
  placeholder: string;
  title?: string;
  link?: string;
  children?: React.ReactNode;
  stats?: React.ReactNode[];
  options?: React.ReactNode[];
  badge?: BadgeInterface['badge'];
  ribbon?: BadgeInterface['ribbon'];
  className?: string;
  size?: 'small' | 'medium' | 'large';
  labels?: React.ReactNode[];
  placeholderStyle?: React.CSSProperties;
}

const CardText = (
  {
    title,
    placeholder,
    link,
    children,
    className,
    stats,
    options,
    badge,
    ribbon,
    size,
    labels,
    placeholderStyle = {}
  }: propsInterface) => {
  let extraClassName = '';
  extraClassName += className ? ` ${className}` : '';
  extraClassName += size ? ` v-card-text--${size}` : '';

  const renderLabels = () => {
    if (!labels || !labels.length) {
      return;
    }

    return (
      <div className='v-card-text-labels'>
        {labels}
      </div>
    );
  }

  return (
    <div className={`v-card-text ${extraClassName}`}>
      <Badge badge={badge} ribbon={ribbon}>
        <div className='o-img-box'>
          {renderLabels()}

          <OptionalLink link={link}>
            <div style={placeholderStyle} className='v-card-text-placeholder'>
              {placeholder}
            </div>
          </OptionalLink>
        </div>

        <div className='o-body'>
          {title &&
            <OptionalLink link={link}>
              <h3 className='o-title'>{title}</h3>
            </OptionalLink>
          }

          {children}
        </div>

        <div className='o-footer'>
          {stats && <StatsIcons icons={stats} />}

          {options && options.length && <OptionsButton key='settings' options={options} /> }
        </div>
      </Badge>
    </div>
  );
}

export default CardText;
